import { BrowserRouter } from "react-router-dom";
import Router from "./routes/router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";
import theme from "./theme/theme";
import { ThemeProvider } from "@emotion/react";

function App() {
  useEffect(() => {
    AOS.init({ 
      duration: 500,
      // once: true
    });
  }, []);

  return (
    <>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <Router />
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
